import { AppImages, variantProvider } from '@/app'
import { modal } from '@codeleap/modals'
import { Image, Text, View, Button } from '@/components'

export const ConfirmExternalLink = ({ resolve }) => {
  return (
    <View variants={['column', 'gap:2']} style={styles.wrapper}>
      <Text text='Leaving Hurd' variants={['h1']} />
      <Image source={AppImages.isolationMode} style={styles.image} />
      <Text
        variants={['p1', 'textCenter']}
        text={`You are leaving our site and we cannot be held responsible for the content of external websites.`}
      />

      <View variants={['column', 'gap:1', 'fullWidth']}>
        <Button debugName='confirmExternalLink:continue' text='Continue' onPress={() => resolve(true)} variants={['large', 'fullWidth']} />
        <Button debugName='confirmExternalLink:stay' text='Stay here' onPress={() => resolve(false)} variants={['outline']} />
      </View>
    </View>
  )
}

const MODAL_MAX_WIDTH = 448

const styles = variantProvider.createComponentStyle(theme => ({
  wrapper: {
    maxWidth: MODAL_MAX_WIDTH,
    ...theme.spacing.padding(2),
    ...theme.presets.center,
  },
  image: {
    width: 64,
    aspectRatio: 257 / 225,
    height: 'auto',
  },
}), true)

export const ConfirmExternalLinkModal = modal()
  .content(({ request }) => <ConfirmExternalLink resolve={request.resolve} />)
  .props({ variants: ['centered'], showClose: false })
